import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Segment } from 'semantic-ui-react';

import './activity.scss';

class SelectedGoal extends Component {
  render() {
    const { t } = this.props;

    return (
      <Segment className="content-segment">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              <label>{t('common.goal').toUpperCase()}</label>
              <br />
              <label className="objectiveGoal-title">
                {t('activity.goal.objective_goal_description')}
              </label>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              <label>{t('common.goal_description').toUpperCase()}</label>
              <br />
              <label className="objectiveGoal-description">
                {t('activity.goal.what_is_a_goal')}
              </label>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <br />
      </Segment>
    );
  }
}

SelectedGoal = withTranslation()(SelectedGoal);

export { SelectedGoal };
